var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookZaks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 30,
    viewBox: "0 0 15 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2615 4.98125H15V0.21125C14.5275 0.14625 12.9027 0 11.0103 0C7.06191 0 4.35714 2.48375 4.35714 7.04875V11.25H0V16.5825H4.35714V30H9.69919V16.5837H13.8801L14.5438 11.2513H9.69794V7.5775C9.69919 6.03625 10.1142 4.98125 12.2615 4.98125Z",
    fill: "#792A81"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookZaks);
export default __webpack_public_path__ + "static/media/facebook_zaks.93b07656f9758583a7bafd1e7f5f6c64.svg";
export { ForwardRef as ReactComponent };